import { render, staticRenderFns } from "./UserQuota.vue?vue&type=template&id=636ce514&"
import script from "./UserQuota.vue?vue&type=script&lang=js&"
export * from "./UserQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports